import BaseTextField from "components/base/TextField"
import useInput from "hooks/use_input"
import useTranslation from "hooks/use_translation"

const FirstName = (props) => {
  const id = "first_name"

  const { fields } = useTranslation()

  const validate = (value) => {
    if (value === "") return fields?.required

    return ""
  }

  const { handleChange, inputValue, errorMessage, handleBlur } = useInput(id, validate)

  return (
    <BaseTextField
      {...props}
      id={id}
      _label={fields?.first_name_title}
      // placeholder={fields?.first_name?.title}
      value={inputValue}
      onChange={handleChange}
      error={errorMessage?.length > 0}
      onBlur={handleBlur}
      helperText={errorMessage}
    />
  )
}

export default FirstName
